/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: unified
 */
import { useCallback, useState } from 'react';
import { supabase } from '../../shared/supabase/supabaseClient';
import { logout } from '../../auth/application/authSession';
import { useAccountSetup } from '../../shell/providers/AccountSetupProvider';
import { showError, showSuccess } from '../../shared/ui/appToast';

export function useClosedBusinessScreen() {
  const [reopening, setReopening] = useState(false);
  // El refresh del provider actualiza el estado React (`organizationClosedAt`)
  // — el del service solo toca el cache de módulo y el gate del navigator
  // seguiría mostrando esta pantalla tras reabrir.
  const { refreshAccountSetup } = useAccountSetup();

  const handleReopen = useCallback(async () => {
    setReopening(true);
    try {
      const { error } = await supabase.rpc('reopen_organization');
      if (error) throw error;
      await refreshAccountSetup({ force: true });
      showSuccess('Negocio reabierto', 'Tu negocio vuelve a estar activo.');
    } catch (e: unknown) {
      const message = e instanceof Error ? e.message : 'Probá de nuevo en unos minutos.';
      showError('No se pudo reabrir', message);
    } finally {
      setReopening(false);
    }
  }, [refreshAccountSetup]);

  const handleLogout = useCallback(async () => {
    try {
      await logout();
    } catch (e: unknown) {
      const message = e instanceof Error ? e.message : 'Probá de nuevo en unos minutos.';
      showError('No se pudo cerrar sesión', message);
    }
  }, []);

  return {
    reopening,
    handleReopen,
    handleLogout,
  };
}
